import { maskDecimal } from '@givebutter/util';
import { faBullhorn } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as LinkedResourcePopover from 'components/tasks/LinkedResourcePopover';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { LinkableCampaign } from 'types/domain';

const CampaignResourcePopover = ({ campaign }: { campaign?: LinkableCampaign }) => {
    const { accountId } = useCurrentAccount();
    if (!campaign) return null;

    return (
        <LinkedResourcePopover.Root>
            <LinkedResourcePopover.Header>
                <FontAwesomeIcon icon={faBullhorn} className="text-gray-500" />
                <LinkedResourcePopover.Link to={`/accounts/${accountId}/campaigns/${campaign.id}`}>
                    {campaign.title}
                </LinkedResourcePopover.Link>
            </LinkedResourcePopover.Header>
            <LinkedResourcePopover.Content>
                <div className="flex flex-col">
                    <p className="text-sm text-gray-500">Total raised</p>
                    <p className="text-base text-gray-900">${maskDecimal(campaign.raised)}</p>
                </div>
                <div className="flex flex-col">
                    <p className="text-sm text-gray-500">Total supporters</p>
                    <p className="text-base text-gray-900">{campaign.donors}</p>
                </div>
            </LinkedResourcePopover.Content>
        </LinkedResourcePopover.Root>
    );
};

export { CampaignResourcePopover };
